import React from "react";
import { CWBDropdown } from "cwb-react";
import { withI18n } from "react-i18next";
import { withRouter } from "react-router-dom";
import styled, { css } from "styled-components";
import Button from "common/Button";
import LegalSection from "common/LegalSection";
import * as SharedStyle from "common/SharedStyledComponents";
import Spinner from "images/spinner.svg";
import { getSupportEmail } from "shared/helpers";

const CWBForgotPwd = ({
  t,
  location,
  accounts,
  clientError,
  isLoading,
  selectedAccount,
  serverError,
  user,
  onChangeField,
  onChangeSelectedAccount,
  onKeyPress,
  onSubmit
}) => {
  return (
    <Base>
      <Wrapper>
        <SharedStyle.FormWrapper>
          <SharedStyle.FormHeader>
            {t("FORGOT PASSWORD")}
          </SharedStyle.FormHeader>
          <SharedStyle.FormBody>
            <SharedStyle.StyledLabel>
              {t("Account Type")}
            </SharedStyle.StyledLabel>
            <CWBDropdown
              className="account-dropdown"
              value={selectedAccount}
              isValueSelected={true}
              placeholder={"Select one"}
              items={accounts}
              onChange={onChangeSelectedAccount}
            />
            <ErrorText>
              <span>{clientError && clientError.accountType}</span>
            </ErrorText>
            <SharedStyle.StyledLabel style={{ marginTop: "24px" }}>
              {t("First name")}
            </SharedStyle.StyledLabel>
            <SharedStyle.StyledInput
              name="firstName"
              className="cwb-material-text-input"
              value={user.firstName}
              onKeyPress={onKeyPress}
              onChange={onChangeField}
            />
            <ErrorText>
              <span>{clientError && clientError.firstName}</span>
            </ErrorText>
            <SharedStyle.StyledLabel style={{ marginTop: "24px" }}>
              {t("Email")}
            </SharedStyle.StyledLabel>
            <SharedStyle.StyledInput
              name="email"
              className="cwb-material-text-input"
              value={user.email}
              onKeyPress={onKeyPress}
              onChange={onChangeField}
            />
            <ErrorText>
              <span>{clientError && clientError.email}</span>
            </ErrorText>
            <SharedStyle.StyledP>
              {t(
                "Your password reset link will be emailed to you. If you have any questions please contact our"
              )}
              &nbsp;
              <a href={`mailto:${getSupportEmail}`}>{t("support team")}</a>.
            </SharedStyle.StyledP>
            <StyledButton onClick={onSubmit}>
              {t("Submit")}
              {isLoading && <StyledImg src={Spinner} />}
            </StyledButton>
            <ErrorText>
              <span>{serverError && serverError.message}</span>
            </ErrorText>
          </SharedStyle.FormBody>
          <LegalSection />
        </SharedStyle.FormWrapper>

        {/* {serverError && serverError.message && (
          <div className="alert alert-danger" style={{ marginTop: "45px" }}>
            <strong>{t("We could not process your request.")}</strong>
            <p>{serverError.message}</p>
          </div>
        )} */}
      </Wrapper>
    </Base>
  );
};

const Base = styled.div`
  width: 100%;
  height: calc(100vh - 60px);
  padding: 5vh 0;
`;

const Wrapper = styled.div`
  width: 610px;
  margin: auto;
  background: white;

  .cwb-dropdown-wrapper {
    margin-top: 8px;
    max-width: 100%;
    height: 40px;

    .cwb-dropdown__single-value {
      font-size: ${p => p.theme["xs-font-size"]};
      font-weight: ${p => p.theme["font-weight-600"]};
    }

    .cwb-dropdown__indicator {
      width: 14px;
    }
  }

  .cwb-dropdown-wrapper > div {
    min-width: 100%;
    max-width: 100%;
  }

  .cwb-dropdown__placeholder {
    color: ${p => p.theme.darkGrey};
    font-size: ${p => p.theme["xs-font-size"]};
  }

  .cwb-dropdown-wrapper > div .cwb-dropdown__control {
    min-height: 40px;
    border: ${props => props.theme.dropDown["border"]} !important;
    border-radius: ${props => props.theme.dropDown["border-radius"]};
  }

  @media (max-width: 475px) {
    width: 100%;
  }
`;

const StyledButton = styled(Button)`
  margin-top: 16px;
`;

const StyledImg = styled.img`
  margin-left: 8px;
`;

const ErrorText = styled.div`
  width: 100%;
  font-size: 12px;
  letter-spacing: 0.21px;
  line-height: 15px;
  margin-top: 8px;

  span {
    font-weight: normal;
    color: red !important;
  }
`;

export default withRouter(withI18n()(CWBForgotPwd));
